import { create } from 'zustand';

const useImageInfoStore = create((set) => ({
  imageInfo: null,
  setImageInfo: (imageInfo) => set({ imageInfo }),
}));

export default useImageInfoStore;
